import React from "react"
import DataTable from "ui/DataTable"
import PropTypes from "prop-types"
import crewMembersColumns from "./columns"

const CrewMembersTable = ({ data, onChange, loading, onEdit, onDelete, onDeactivate, onActivate }) => {
  const columns = crewMembersColumns(onEdit, onDelete, onDeactivate, onActivate)
  return (
    <DataTable
      columns={columns}
      dataSource={data}
      pagination={false}
      onChange={onChange}
      loading={loading}
      scroll={{ x: "max-content" }}
    />
  )
}

CrewMembersTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onDeactivate: PropTypes.func,
  onActivate: PropTypes.func
}

export default React.memo(CrewMembersTable)
